import { CenteredLoading, changeDocumentLanguage } from '@healthhub/react-ui';
import { useEffect } from 'react';
import { useLocation } from 'react-router';

import { i18n } from 'i18n';

import { NON_SCROLL_TOP_PATH } from '@shared/constants/nonScrollTopPath';
import useDocumentTitle from '@shared/hooks/useDocumentTitle';
import useGlobalLoading from '@shared/hooks/useGlobalLoading';
import useInitGTM from '@shared/hooks/useInitGTM';
import useServiceCatalog from '@shared/hooks/useServiceCatalog';
import { useGetModulesMaintenanceQuery } from '@shared/services/maintenance';
import { useAppDispatch } from '@shared/stores/rootTypes';

import { healthierSGAction } from '@features/HealthierSG/store/slices';

interface RouteWrapperProps {
  children: JSX.Element;
  path: string;
  serviceCatalogCode: string;
}

export const RouteWrapper = ({ children, path, serviceCatalogCode }: RouteWrapperProps) => {
  const isGlobalLoading = useGlobalLoading();

  useDocumentTitle({});

  // Root prefetch API
  // Prefetch of the API to reduce loading
  useGetModulesMaintenanceQuery({ Code: serviceCatalogCode }, { skip: !serviceCatalogCode });
  useServiceCatalog(!serviceCatalogCode);

  // Temporary solution for kaki hhm, to be removed from hh+
  const { search } = useLocation();
  const kakiBadge = new URLSearchParams(search).get('kaki');
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (kakiBadge === '1') dispatch(healthierSGAction.setKakiBadge(true));
  }, [dispatch, kakiBadge]);

  useInitGTM();

  useEffect(() => {
    changeDocumentLanguage(i18n.language);
  }, []);

  useEffect(() => {
    setTimeout(() => {
      if (NON_SCROLL_TOP_PATH.includes(path)) return;

      window.scrollTo(0, 0);
    }, 0);
  }, [path]);

  if (isGlobalLoading) return <CenteredLoading />;

  return children;
};
